
/**
 * Generates a SHA-256 hash for the given form response data.
 * This ensures non-repudiation by binding the user, timestamp, and data content.
 */
export async function generateResponseHash(
  userId: string,
  timestamp: string,
  data: Record<string, any>
): Promise<string> {
  const payload = JSON.stringify({
    userId,
    timestamp,
    data
  });

  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(payload);

  // Use Web Crypto API
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);

  // Convert buffer to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
}

export async function verifyResponseHash(
  userId: string,
  timestamp: string,
  data: Record<string, any>,
  expectedHash: string
): Promise<boolean> {
  const calculatedHash = await generateResponseHash(userId, timestamp, data);
  return calculatedHash === expectedHash;
}
